import { useEffect, useRef, type PropsWithChildren } from "react";
import { useEditor } from "@nkitaa/builder-engine";
import { resolveBodyColor } from "../theme/themeValueResolver";
import { useWBTheme } from "../theme/WBThemeRuntimeProvider";
import { WB_REVEAL_CSS } from "./reveal";

export function UnknownComponent(props: Record<string, unknown>) {
  const missingType = String(props.missingType ?? "Unknown");
  return (
    <div
      style={{
        border: "1px dashed #d1d5db",
        padding: "0.75rem",
        fontSize: "0.875rem",
      }}
    >
      Unsupported component: {missingType}
    </div>
  );
}

export function NoopComponent() {
  return null;
}

export function PageWrapper({ children }: PropsWithChildren) {
  const { currentColorPalette, currentFonts, bodyTheme } = useWBTheme();
  const { actions, editorEnabled } = useEditor((state) => ({
    editorEnabled: state.options.enabled,
  }));
  const previousEditorEnabled = useRef(editorEnabled);
  const resolvedBodyColor = resolveBodyColor({
    bodyTheme,
    palette: currentColorPalette,
  });

  useEffect(() => {
    if (!previousEditorEnabled.current && editorEnabled) {
      actions.clearEvents();
    }
    previousEditorEnabled.current = editorEnabled;
  }, [actions, editorEnabled]);

  return (
    <div
      className="websitebuilder"
      style={{
        // Minus the runtime legal line App.tsx mounts BELOW this wrapper (it
        // publishes its measured height): a short page — login, register —
        // otherwise is always 100dvh + one row, i.e. a permanent scrollbar
        // with the legal links under the fold.
        minHeight: "calc(100dvh - var(--wb-legal-line-h, 0px))",
        color: resolvedBodyColor,
        backgroundColor: currentColorPalette.background,
        fontFamily: currentFonts.body,
      }}
    >
      {children}
      {/* Static scroll-reveal keyframes for the declarative section `reveal`
          prop (see ./reveal.ts). Constant CSS, no user input. */}
      <style>{WB_REVEAL_CSS}</style>
    </div>
  );
}

export function Body({ children }: PropsWithChildren) {
  return <main>{children}</main>;
}

export function AppBar({ children }: PropsWithChildren) {
  return <>{children}</>;
}

export function Footer({ children }: PropsWithChildren) {
  return <>{children}</>;
}
